import React from 'react';
import { Box, Container, Step, StepLabel, Stepper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import PageMeta from 'components/seo/PageMeta';

const steps = ['Carrito', 'Envío', 'Pago', 'Confirmación'];

const CheckoutLayout: React.FC = () => (
  <>
    <PageMeta title="Checkout" />
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Stepper activeStep={1} alternativeLabel sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box>
        <Outlet />
      </Box>
    </Container>
  </>
);

export default CheckoutLayout;
